export const MaterialErrorCodes = {
  required: 'material.required',
  unavailable: 'material.unavailable',
  incompatible: 'material.incompatible',
  notAllowed: 'material.notAllowed',
  invalidProperties: 'material.invalidProperties'
}
